import { IRegisterUser } from './../../typings/board/Models';
import { IPromise, IHttpService } from "angular";

export const REGISTER_SERVICE = "registerService";
export class RegisterService {

    static $inject = ["$http"];
    constructor(private $http: IHttpService) { }

    register(email: string, username: string, password: string, ticket: string): IPromise<void> {
        return this.$http.post<void>("api/register/register",  {
            email: email,
            username: username,
            password: password,
            ticket: ticket
        } as IRegisterUser).then(response => response.data);
    }
}


// WEBPACK FOOTER //
// ./app/register/register.service.ts